<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">13th MONTH MONITORING</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense class="mt-3">
        <v-col
          md="2"
          cols="12"
        >
          <v-select
            v-model="selection"
            class="mx-2"
            dense
            outlined
            label="Selection"
            :items="['Active','Temporary Deactivate','Permanent Deactivate']"
          ></v-select>
        </v-col>
        <v-col
          md="2"
          cols="12"
        >
          <v-select
            v-model="year"
            class="mx-2"
            :items="year_items"
            item-value="year"
            item-text="year"
            label="Year Of"
            required
            :rules="rules.combobox_rule"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col
          md="3"
          cols="12"
        >
          <v-select
            outlined
            class="mx-2"
            v-model="category_id"
            dense
            label="Category"
            :items="category_items"
            item-value="id"
            item-text="category"
            :rules="rules.combobox_rule"
          ></v-select>
        </v-col>
      </v-row>

      <v-btn class="w-full" color="success" @click="view_initialize"
             v-if="!is_loading">
        View
      </v-btn>
      <v-data-table dense
                    :headers="headers"
                    :items="payroll_data"
                    :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>13th Month Data</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            Total: {{ total_amount }}
            <v-text-field
              class="mx-2"
              :append-icon="icons.mdiAccountSearch"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td>
              {{
                item.name
              }}
            </td>
            <td>
              <v-data-table v-if="item.jan_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.jan_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.feb_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.feb_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.mar_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.mar_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.apr_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.apr_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.may_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.may_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.jun_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.jun_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.jul_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.jul_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.aug_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.aug_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.sep_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.sep_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.oct_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.oct_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.nov_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.nov_data"
              >
              </v-data-table>
            </td>
            <td>
              <v-data-table v-if="item.dec_data.length>0"
                            dense
                            :headers="headers2"
                            disable-pagination
                            hide-default-footer
                            hide-default-header
                            :items="item.dec_data"
              >
              </v-data-table>
            </td>
            <td>
              {{ formatPrice(item.amount) }}
            </td>
            <td>
              {{ formatPrice(item.total_amount) }}
            </td>
            <td>
              {{ item.remarks }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
import {
  mdiAccountOutline,
  mdiAccountCashOutline,
  mdiInformationOutline,
  mdiAccountSearch
} from "@mdi/js";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {
    is_loading: false,
    total_amount: '0.00',
    selection: '',
    status: '',
    year: '',
    year_items: [],
    payroll_data: [],
    duration: '',
    sorted_by: 'Name',
    bank_type: 'All',
    bank_type_items: [],
    position: 'All',
    position_items: [],
    batch_no: '',
    batch_no_items: [],
    category_id: '',
    category_items: [],
    search: '',
    headers: [
      {text: 'Name', value: 'date_of_deposit', sortable: false},
      {text: 'Jan.', value: 'employee.last_name', sortable: false},
      {text: 'Feb.', value: 'amount', sortable: false},
      {text: 'Mar.', value: 'bank_code_name', sortable: false},
      {text: 'Apr.', value: 'bank_code_name', sortable: false},
      {text: 'May', value: 'bank_code_name', sortable: false},
      {text: 'Jun.', value: 'bank_code_name', sortable: false},
      {text: 'Jul.', value: 'bank_code_name', sortable: false},
      {text: 'Aug.', value: 'bank_code_name', sortable: false},
      {text: 'Sep.', value: 'bank_code_name', sortable: false},
      {text: 'Oct.', value: 'bank_code_name', sortable: false},
      {text: 'Nov.', value: 'bank_code_name', sortable: false},
      {text: 'Dec.', value: 'bank_code_name', sortable: false},
      {text: 'Total', value: 'bank_code_name', sortable: false},
      {text: 'Grand Total', value: 'bank_code_name', sortable: false},
      {text: 'Status', value: 'bank_code_name', sortable: false},
    ],
    headers2: [
      {value: 'no_work', sortable: false},
      {value: 'no_absent', sortable: false},
      {value: 'highest_rate', sortable: false},
      {value: 'total', sortable: false},
    ],
  }
}
export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiAccountCashOutline,
        mdiInformationOutline,
        mdiAccountSearch,
      },
      is_deleting: false,
    }
  },
  data() {
    return initialState()
  },
  mounted() {
    this.initialize_data()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('category', ['list_of_category_have_thirten_month_pay']),
    ...mapActions('salaries_and_wages', ['initialize_salaries_employee', 'initialize_payroll_selected_category', 'initialize_payroll', 'payroll']),
    ...mapActions('thirten_month_pay', ['initialize_thirten_month_payroll', 'initialize_thirten_month_payroll_counter']),
    initialize_data() {
      this.initialize_salaries_employee()
        .then(response => {
          this.year_items = response.data[0].month_of
          this.category_items = response.data[0].category
        })
        .catch(error => {
          console.log(error)
        })
    },
    date_format(value) {
      return moment(value)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    async view_initialize() {
      this.payroll_data = []
      this.is_loading = true
      const data = new FormData()
      data.append('year', this.year);
      data.append('remarks', this.selection);
      data.append('category_id', this.category_id);
      data.append('is_monitoring', 1);
      let tot = 0
      let count_get = 50
      await this.initialize_thirten_month_payroll_counter(data)
        .then(response => {

          let num = response.data / count_get;
          let remaining = num % 1;
          let counter = parseInt(num)
          if (remaining !== 0) {
            counter++
          }
          if (counter == 0) {
            counter = 1
          }
          for (let i = 0; i < counter; i++) {
            data.append('skip', i * count_get);
            data.append('take', count_get);
            this.initialize_thirten_month_payroll(data)
              .then(response => {
                response.data.forEach((data) => {
                  tot += parseFloat(data.total_amount)
                  this.total_amount = this.formatPrice(tot)
                  this.payroll_data.push(data)
                });
              })
              .catch(error => {
                console.log(error)
              })
            // this.is_loading=(i===counter)
          }
        })
        .catch(error => {
          console.log(error)
        })
      this.total_amount = this.formatPrice(tot)
      this.is_loading = false
    },
  },
}
</script>
